import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SelectionContextType {
  selectedCount: number;
  setSelectedCount: (count: number) => void;
  clearSelection: () => void;
  onClearSelection?: () => void;
  setOnClearSelection: (callback: () => void) => void;
}

const SelectionContext = createContext<SelectionContextType | undefined>(undefined);

export const SelectionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedCount, setSelectedCount] = useState(0);
  const [onClearSelection, setOnClearSelection] = useState<(() => void) | undefined>(undefined);

  const clearSelection = () => {
    if (onClearSelection) {
      onClearSelection();
    }
    setSelectedCount(0);
  };

  return (
    <SelectionContext.Provider
      value={{
        selectedCount,
        setSelectedCount,
        clearSelection,
        onClearSelection,
        setOnClearSelection,
      }}
    >
      {children}
    </SelectionContext.Provider>
  );
};

export const useSelection = () => {
  const context = useContext(SelectionContext);
  if (context === undefined) {
    throw new Error('useSelection must be used within a SelectionProvider');
  }
  return context;
};
